// Файл session_storage.js

/**
 * Модуль обслуживает сценарий `session_storage` в разделе `utils`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

const get_session_storage = () => {
    if (
        typeof window === 'undefined'
        || !window.sessionStorage
    ) {
        return null;
    }

    return window.sessionStorage;
};


export const session_storage = {
    get_item: (key) => {
        try {
            return get_session_storage()?.getItem(key) ?? null;

        } catch (error) {
            return null;
        }
    },

    set_item: (key, value) => {
        try {
            const target = get_session_storage();

            if (!target) {
                return false;
            }

            target.setItem(key, String(value));

            return true;

        } catch (error) {
            return false;
        }
    },

    remove_item: (key) => {
        try {
            get_session_storage()?.removeItem(key);

            return true;

        } catch (error) {
            return false;
        }
    },

    clear: () => {
        try {
            get_session_storage()?.clear();

            return true;

        } catch (error) {
            return false;
        }
    },
};
